export var AlertInfo;
(function (AlertInfo) {
    // 三方異常
    AlertInfo[AlertInfo["DEPOSIT_WAY_FULL_CASH_REACHED"] = 21] = "DEPOSIT_WAY_FULL_CASH_REACHED";
    AlertInfo[AlertInfo["TRANSFER_STATUS_NOT_MATCH"] = 22] = "TRANSFER_STATUS_NOT_MATCH";
    AlertInfo[AlertInfo["NO_TRANSFER_LOG_IN_THIRD_PARTY"] = 23] = "NO_TRANSFER_LOG_IN_THIRD_PARTY";
    AlertInfo[AlertInfo["BET_REVENUE_3W"] = 25] = "BET_REVENUE_3W";
    AlertInfo[AlertInfo["WITHDRAW_REVENUE_3W"] = 29] = "WITHDRAW_REVENUE_3W";
    AlertInfo[AlertInfo["REAL_NAME_DUPLICATE"] = 27] = "REAL_NAME_DUPLICATE";
    AlertInfo[AlertInfo["RC_WARNED_USER_GAME_LOGIN"] = 28] = "RC_WARNED_USER_GAME_LOGIN";
    AlertInfo[AlertInfo["TRC_BIND"] = 26] = "TRC_BIND";
    AlertInfo[AlertInfo["WALLET_DUPLICATE"] = 30] = "WALLET_DUPLICATE";
    AlertInfo[AlertInfo["DEPOSIT_ORDER_CREATING_TOO_FREQUENTLY"] = 31] = "DEPOSIT_ORDER_CREATING_TOO_FREQUENTLY";
    AlertInfo[AlertInfo["LOCATION_NOT_MATCH"] = 32] = "LOCATION_NOT_MATCH";
    AlertInfo[AlertInfo["DUPLICATE_FINGERPRINT"] = 33] = "DUPLICATE_FINGERPRINT"; // 重複指紋
})(AlertInfo || (AlertInfo = {}));
//# sourceMappingURL=AlertInfo.js.map